import React from "react";
import { Text } from "braid-design-system";
import type { FieldConfig, RenderField } from "./transactionScreenTypes";

type TransactionPaymentSectionProps = {
    renderField: RenderField;
    isEnabled: boolean;
};

const TransactionPaymentSection: React.FC<TransactionPaymentSectionProps> = ({ renderField, isEnabled }) => {
    if (!isEnabled) {
        return null;
    }

    return (
        <section className="transaction-section">
            <div className="transaction-section-heading">
                <Text weight="strong">Payment</Text>
            </div>
            <div className="transaction-form-grid">
                {renderField({ key: "paymentMode", label: "Payment Mode", type: "select", options: ["Cash", "Card", "Credit"] } as FieldConfig)}
                {renderField({ key: "paymentAmount", label: "Amount", type: "number" } as FieldConfig)}
                {renderField({ key: "paymentRef", label: "Reference" } as FieldConfig)}
            </div>
        </section>
    );
};

export default TransactionPaymentSection;
